export const shopDTO = data => {
    return {
        ID: {
            default: data.ID,
            hidden: true,
        },
        address_1: {
            label: "address",
            sub: "1",
            default: data.address_1 || '',
            rule: ['required'],
            address_1: data.address_1 || '',
        },
        address_2: {
            label: "address",
            sub: "2",
            default: data.address_2 || '',
            address_2: data.address_2 || '',
        },
        address_3: {
            label: "address",
            sub: "3",
            default: data.address_3 || '',
            address_3: data.address_3 || '',
        },
        cgv_url: {
            label: "cgvUrl",
            default: data.cgv_url || '',
            cgv_url: data.cgv_url || '',
        },
        country: {
            label: "country",
            default: data.country,
            country: data.country,
            rule: ['required'],
        },
        city: {
            label: "city",
            default: data.city,
            city: data.city,
            rule: ['required'],
        },
        currency: {
            label: "currency",
            default: data.currency,
            currency: data.currency,
            rule: ['required'],
        },
        deleted: {
            default: data.deleted,
            hidden: true,
        },
        description: {
            label: "description",
            default: data.description,
            description: data.description,
            rule: ['required'],
        },
        email: {
            label: "email",
            default: data.email,
            email: data.email,
            rule: ['required', 'email'],
        },
        latitude: {
            label: "latitude",
            default: data.latitude,
            latitude: data.latitude,
        },
        longitude: {
            label: "longitude",
            default: data.longitude,
            longitude: data.longitude,
        },
        name: {
            label: "name",
            default: data.name,
            name: data.name,
            rule: ['required'],
        },
        phone: {
            label: "phone",
            default: data.phone || '',
            phone: data.phone || '',
            type: 'phone',
        },
        portal_code: {
            label: "portalCode",
            default: data.portal_code,
            portal_code: data.portal_code,
        },
        short_url: {
            label: "shortUrl",
            default: data.short_url,
            short_url: data.short_url,
            type: "link",
        },
        timezone: {
            label: "timezone",
            default: data.timezone,
            timezone: data.timezone,
            rule: ['required'],
        },
        zip_code: {
            label: "zipCode",
            default: data.zip_code,
            zip_code: data.zip_code,
            rule: ['required'],
        },
    }
}